import { OperatingPerformanceData } from '../../services/operatingPerformanceApi';

const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function PositionsTable({
  positions,
}: {
  positions: OperatingPerformanceData['positions'];
}) {
  if (positions.length === 0) return <div className="op-empty">포지션이 없습니다.</div>;
  return (
    <div className="op-table-wrap">
      <table className="op-table">
        <thead>
          <tr><th>종목</th><th>수량</th><th>평가액</th><th>수익률</th><th>평가손익</th></tr>
        </thead>
        <tbody>
          {positions.map((pos) => (
            <tr key={pos.symbol}>
              <td>{pos.symbol}</td>
              <td>{pos.qty.toFixed(2)}</td>
              <td>{moneyFormatter.format(pos.market_value)}</td>
              <td className={pos.unrealized_pl_percent >= 0 ? 'good-text' : 'bad-text'}>
                {pos.unrealized_pl_percent.toFixed(2)}%
              </td>
              <td className={pos.unrealized_pl >= 0 ? 'good-text' : 'bad-text'}>
                {moneyFormatter.format(pos.unrealized_pl)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function BreakdownTable({
  rows,
}: {
  rows: OperatingPerformanceData['tradeBreakdown'];
}) {
  return (
    <div className="op-table-wrap">
      <table className="op-table">
        <thead><tr><th>유형</th><th>건수</th><th>손익</th></tr></thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.type}>
              <td>{row.type}</td>
              <td>{row.count}</td>
              <td className={row.profit >= 0 ? 'good-text' : 'bad-text'}>
                {moneyFormatter.format(row.profit)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function TradesTable({
  trades,
}: {
  trades: OperatingPerformanceData['trades'];
}) {
  if (trades.length === 0) return <div className="op-empty">거래 기록이 없습니다.</div>;
  return (
    <div className="op-table-wrap">
      <table className="op-table">
        <thead>
          <tr><th>일시</th><th>종목</th><th>유형</th><th>수익률</th><th>손익</th></tr>
        </thead>
        <tbody>
          {trades.map((trade) => (
            <tr key={trade.id}>
              <td>{new Date(trade.executed_at).toLocaleDateString()}</td>
              <td>{trade.symbol}</td>
              <td>{trade.trade_type}</td>
              <td className={trade.profit_percent >= 0 ? 'good-text' : 'bad-text'}>
                {trade.profit_percent.toFixed(2)}%
              </td>
              <td className={(trade.profit_amount ?? 0) >= 0 ? 'good-text' : 'bad-text'}>
                {moneyFormatter.format(trade.profit_amount ?? 0)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
